import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "UI/Box";
import { Button } from "UI/Button";
import { Checkbox } from "UI/Form/Checkbox";
import { Grid } from "UI/Grid";
import { Layout } from "components/layouts/Layout";
import { useSwitchHideInactiveWalletsMutation } from "api/baseAPI/pointManagers";
import { useSelectedPointManager } from "hooks/useSelectedEntity";
import {
  useErrorNotification,
  useSuccessNotification,
} from "utils/notificationWrappers";

export const WalletSettings = () => {
  const { t } = useTranslation();
  const selectedPointManager = useSelectedPointManager();

  const breadCrumbs = [
    [t("Управление"), ""],
    [t("Настройки кошельков"), ""],
  ];

  const [hideInactiveWallets, setHideInactiveWallets] = useState<boolean>(
    selectedPointManager?.hide_inactive_wallets || false
  );
  const [initialValue, setInitialValue] = useState<boolean>(
    selectedPointManager?.hide_inactive_wallets || false
  );

  const [switchHideInactiveWallets, switchHideInactiveWalletsMeta] =
    useSwitchHideInactiveWalletsMutation();

  useEffect(() => {
    if (selectedPointManager?.hide_inactive_wallets !== undefined) {
      setHideInactiveWallets(selectedPointManager.hide_inactive_wallets);
      setInitialValue(selectedPointManager.hide_inactive_wallets);
    }
  }, [selectedPointManager?.hide_inactive_wallets]);

  useEffect(() => {
    if (switchHideInactiveWalletsMeta.isSuccess) {
      setInitialValue(hideInactiveWallets);
    }
  }, [switchHideInactiveWalletsMeta.isSuccess]);

  const handleSave = () => {
    if (selectedPointManager?.id) {
      switchHideInactiveWallets({ id: selectedPointManager.id });
    }
  };

  useSuccessNotification([switchHideInactiveWalletsMeta]);
  useErrorNotification([switchHideInactiveWalletsMeta]);

  const isButtonDisabled =
    hideInactiveWallets === initialValue ||
    switchHideInactiveWalletsMeta.isLoading;

  return (
    <Layout title={t("Настройки кошельков")} breadCrumbs={breadCrumbs}>
      <Box>
        <Grid container p={24} hSpace={24} vSpace={24}>
          <Grid item sm={12}>
            <Checkbox
              value={hideInactiveWallets}
              onChange={(checked) => setHideInactiveWallets(checked)}
              label={t("Скрыть отключенные кошельки")}
            />
          </Grid>
          <Grid item sm={12} lg={2}>
            <Button
              fullwidth
              disabled={isButtonDisabled}
              variant="outlined"
              onClick={handleSave}
            >
              {t("Сохранить")}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};
